let language = {
    "ESHOPPER-ALERT-INFO-TITLE": "重发电子邮箱",
    "ESHOPPER-ALERT-INFO-CONTENT": "重新发送电子邮箱成功",
    "ESHOPPER-ALERT-WARN-CONTENT": "缺少邮政编码，请填写",
    "ESHOPPER-ALERT-WARN-TITLE-SAVE": "失败",
    "ESHOPPER-ALERT-WARN-CONTENT-SAVE": "保存失败! ",
    "ESHOPPER-ALERT-MESSAGE": "保存成功!",
};

export { language }